"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPickerCustomInput = void 0;
const startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
const react_1 = __importStar(require("react"));
const DayPickerInput_1 = __importDefault(require("react-day-picker/DayPickerInput"));
require("react-day-picker/lib/style.css");
const dateUtils = __importStar(require("../../utils/dateUtils"));
require("./DayPicker.scss");
const DayPickerYearMonthForm_1 = require("./DayPickerYearMonthForm");
const DayPickerCustomInput = (props) => {
    var _a;
    const dayPickerRef = (0, react_1.useRef)(null);
    function handleDayPickerVisibleChange(visible) {
        if (props.onDayPickerVisibleChange) {
            props.onDayPickerVisibleChange(visible);
        }
    }
    /** The visible month in the day picker. */
    const [month, setMonth] = (0, react_1.useState)(props.date);
    // Close when clicked outside.
    (0, react_1.useEffect)(() => {
        function handleClickOutside(event) {
            if (dayPickerRef.current &&
                dayPickerRef.current.getDayPicker() &&
                !dayPickerRef.current.getInput().contains(event.target) &&
                !dayPickerRef.current.getDayPicker().dayPicker.contains(event.target)) {
                dayPickerRef.current.hideDayPicker();
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dayPickerRef]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (props.dayPickerVisible) {
            (_a = dayPickerRef.current) === null || _a === void 0 ? void 0 : _a.showDayPicker();
        }
        else {
            (_b = dayPickerRef.current) === null || _b === void 0 ? void 0 : _b.hideDayPicker();
        }
    }, [props.dayPickerVisible]);
    return (react_1.default.createElement(DayPickerInput_1.default, { ref: dayPickerRef, onDayPickerShow: () => handleDayPickerVisibleChange(true), onDayPickerHide: () => handleDayPickerVisibleChange(false), classNames: {
            container: "DayPickerInput DayPickerCustomInput " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""),
            overlayWrapper: "DayPickerInput-OverlayWrapper",
            overlay: "DayPickerInput-Overlay",
        }, value: props.date, onDayChange: props.onDateChange, placeholder: "---", format: dateUtils.DEFAULT_DATE_FORMAT, formatDate: (date, format) => {
            if (date) {
                return dateUtils.formatDate(date, { format });
            }
            else {
                return "";
            }
        }, parseDate: dateUtils.parseDate, inputProps: {
            id: props.id,
            className: `form-control` +
                `${props.isValid ? " is-valid" : ""}` +
                `${props.isInvalid ? " is-invalid" : ""}`,
            readOnly: true,
            disabled: !props.editable,
        }, dayPickerProps: {
            numberOfMonths: 1,
            months: dateUtils.MONTHS,
            weekdaysLong: dateUtils.WEEKDAYS_LONG,
            weekdaysShort: dateUtils.WEEKDAYS_SHORT,
            firstDayOfWeek: 1,
            todayButton: props.todayButton,
            fromMonth: (0, startOfMonth_1.default)(props.minDate),
            toMonth: (0, startOfMonth_1.default)(props.maxDate),
            month: month,
            disabledDays: [{ before: props.minDate }, { after: props.maxDate }],
            captionElement: ({ date }) => (react_1.default.createElement(DayPickerYearMonthForm_1.DayPickerYearMonthForm, { date: date, minYear: props.minDate.getFullYear(), maxYear: props.maxDate.getFullYear(), onChange: setMonth })),
        }, keepFocus: false }));
};
exports.DayPickerCustomInput = DayPickerCustomInput;
